import * as React from 'react';

import { PropertyListingBadgeModel } from 'models';

import { UitkLayoutPosition } from 'uitk-react-layout-position';

import { BadgeGenerator } from 'components/common/badge-generation';

interface RenderBadgeProps {
  propertyListingBadgeModel?: PropertyListingBadgeModel;
  pinnedDefaultListing?: boolean;
  rfrr?: String;
}

export const PrimaryBadge: React.FunctionComponent<RenderBadgeProps> = ({ propertyListingBadgeModel, pinnedDefaultListing }) => {
  const { primary } = { ...propertyListingBadgeModel };
  const primaryIsSafe = primary && (primary.text || primary.icon || primary.mark);

  if (!primaryIsSafe) {
    return null;
  }

  const position = pinnedDefaultListing
    ? { top: 'twelve' as 'twelve', left: 'three' as 'three', zindex: 'layer3' as 'layer3' }
    : { top: 'one' as 'one', left: 'three' as 'three', zindex: 'layer3' as 'layer3' };

  return (
    <UitkLayoutPosition type="absolute" position={position} data-stid={'layout-position'}>
      <BadgeGenerator badge={primary || {}} badgeClasses="all-t-margin-two" />
    </UitkLayoutPosition>
  );
};

PrimaryBadge.displayName = 'PrimaryBadge';
